import { Group } from '@ih/app/shared/apis/interfaces';

export class SetGroup {
  public static readonly type = '[Group] SetGroup';
  constructor(public readonly group: Group | null) {}
}
